import {Modal} from './Modal';
import ajax from '../utils/ajaxRequest';
import $ from 'jquery';
import _ from 'lodash';

export class FollowData extends Modal {

    constructor(followDataElement) {
        super({
            width: 300,
            displayHeader: false,
            backdropClose: true,
            scrollLock: false,
            focusTrap: true,
            ariaDescribedby: 'modal-desc',
            ariaLabelledby: 'modal-title',
            previouslyActiveElement: $(followDataElement),
        });
        this.followDataElement = followDataElement;
        this.overlayContent = _.template(`
            <div class="ar-white-box">
                <div class="ar-white-box-border">
                <h3 id="modal-title" class="ar-white-box-inclusively-hidden"><%- title %></h3>
                <div tabindex="0" role="button" title="Close" aria-label="Close" class="ar-white-box-close"></div>
                    <p id="modal-desc"><%- message %></p>
                    <div class="text-center">
                        <a <%- attr1 %> class="ar-button ar-button--pill ar-button--ok"><%- label1 %></a>
                        <a <%- attr2 %> class="ar-button ar-button--pill ar-button--transparent-border"><%- label2 %></a>
                    </div>
                </div>
            </div>
        `);

        this._modalConfirmBtnEl = undefined;
    };

    /**
    * Initialise this class
    */
    init() {
        super.init();
    };

    /**
     * Handles on click and keypress event
     */
    _onClickHandle(e) {
        if (e.type === 'keypress' && e.which !== 13) {
            return;
        }
        var $currentTarget = $(e.currentTarget);
        var data = $currentTarget.data();

        if(data.isfollowed) {
            this.config.parentElement.appendChild(this._modalRootEl);
            super.setContent(this.overlayContent({
                'attr1': 'role=button tabindex=0',
                'label1': data.okbutton,
                'attr2': 'role=button tabindex=0',
                'label2': data.cancelbutton,
                'message': data.confirmationmessage,
                'title': "Unfollow confirmation"
            }));

            super.initCloseButton('.ar-white-box-close');
            super.initButtonWithCallback('.ar-button--transparent-border', () => {
                super.hide();
            })
            super.initButtonWithCallback('.ar-button--ok', () => {
                this._onConfirmBtnClick(data, $currentTarget);
            })
            super.show();
        } else {
            this.followOrUnfollow(data, $currentTarget);
        }
    };


    followOrUnfollow(data, currentTarget) {
        ajax.post("/api/follow/" + data.type, {
            "ItemId": data.guid,
            "SetFollowed" : !(data.isfollowed)
        }).then(response => {
            if(!response.ErrorMessage) {
                currentTarget.attr("data-isfollowed", response.IsFollowed).data("isfollowed", response.IsFollowed);

                if (data.deleteParent) {
                    currentTarget.parents(data.deleteParent).remove();
                }
                if(data.unfollowText && response.IsFollowed) {
                    currentTarget.text(data.unfollowText)
                }
                if(data.followText && !response.IsFollowed) {
                    currentTarget.text(data.followText)
                }
            } else {
                this.config.parentElement.appendChild(this._modalRootEl);
                super.setContent(this.overlayContent({
                    'attr1': `href=${logInPopupJsonSettings.LogInUrl}?followItem=${data.guid}`,
                    'label1': logInPopupJsonSettings.LoginButton,
                    'attr2': `href=${logInPopupJsonSettings.RegisterUrl}`,
                    'label2': logInPopupJsonSettings.RegisterButton,
                    'message': response.ErrorMessage.replace(/[\[\]]/g, '').trim(),
                    'title': "Unable to follow"
                }));

                super.initCloseButton('.ar-white-box-close');
                super.show();
            }
        });
    }
    
    _onConfirmBtnClick(data, currentTarget) {
        this.followOrUnfollow(data, currentTarget);
        this.hide();
    }

    initEventListeners() {
        super.initEventListeners();
        $(document).on('click keypress', this.followDataElement, this._onClickHandle.bind(this));
    };
}

export let show = (followDataElement) => new FollowData(followDataElement).init();